import isPlainObject from "lodash/isPlainObject";

/**
 * Finds all paths of an object that have values. This was designed only for
 * the error response so each value is expected to be either a plain object or
 * an array of strings. It will return an array of key paths that have an error
 * to display.
 *
 * @param {object} errorsMap - just a plain object with possible nested objects
 * @param {array} stem - keeps track of the current stem
 */
const findPaths = (errorsMap, stem = []) => {
	if (!isPlainObject(errorsMap)) {
		return [];
	}

	let keyPaths = [];
	const mapKeys = Object.keys(errorsMap);

	mapKeys.forEach((ii) => {
		const value = errorsMap[ii];

		if (isPlainObject(value)) {
			const newStem = stem.concat([ii]);
			const paths = findPaths(value, newStem);

			keyPaths = keyPaths.concat(paths);
		} else {
			keyPaths.push(stem.concat(ii));
		}
	});

	return keyPaths;
};

export default findPaths;
